import { render, staticRenderFns } from "./sampleDistribution.vue?vue&type=template&id=506e751f"
import script from "./sampleDistribution.ts?vue&type=script&lang=js&external"
export * from "./sampleDistribution.ts?vue&type=script&lang=js&external"
import style0 from "./sampleDistribution.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports